import { useCallback, useEffect, useState } from 'react';
import { OTP_RESEND_COOLDOWN_S } from '../constants/quick-purchase.constants';

interface UseResendCooldownReturn {
  /** Seconds remaining before resend is allowed again. 0 means ready. */
  cooldownSeconds: number;
  /** Call this immediately after a successful resend to start the countdown. */
  startCooldown: () => void;
}

/**
 * Manages the 30-second cooldown between OTP resend attempts.
 * Counts down from OTP_RESEND_COOLDOWN_S to 0, then allows resending again.
 */
export const useResendCooldown = (): UseResendCooldownReturn => {
  const [cooldownSeconds, setCooldownSeconds] = useState(0);

  useEffect(() => {
    if (cooldownSeconds <= 0) return;
    const timer = setTimeout(() => setCooldownSeconds((s) => s - 1), 1000);
    return () => clearTimeout(timer);
  }, [cooldownSeconds]);

  const startCooldown = useCallback(() => {
    setCooldownSeconds(OTP_RESEND_COOLDOWN_S);
  }, []);

  return { cooldownSeconds, startCooldown };
};
